export const AccordionImageItems = {
    init: () => {
        const accordionElements = document.querySelectorAll(
            '[data-accordion-item]',
        );
        //  initail check
        // for (let i = 0; i < accordionElements.length; i++) {
        //     if (!accordionElements[i].classList.contains('is-active')) {
        //         document
        //             .querySelector(`[data-masonry-images-${i + 1}]`)
        //             .classList.remove('hide');
        //     }
        // }

        for (let i = 0; i < accordionElements.length; i++) {
            accordionElements[i].addEventListener('click', function () {
                // console.log('click accordion ');

                const imageElement = document.querySelector(
                    `[data-masonry-images-${i + 1}]`,
                );

                const masonryImagesBlock = document.querySelectorAll(
                    '.accordion-masonry__images',
                );

                if (imageElement) {
                    for (const el of masonryImagesBlock) {
                        if (!el.classList.contains('hide')) {
                            el.classList.add('hide');
                        }
                    }
                    imageElement.classList.toggle('hide');
                }
            });
        }
    },
};
